import appPaths from "./app.paths";
import asyncComponent from "./async-component";

export default [

  /// My Account
  {
    path: appPaths.authProfile,
    name: 'auth-my-account',
    component: asyncComponent(() => import("../modules/auth/auth-my-account.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Account",
      title: "My Account",
    },
  },

  /// Orders
  {
    path: appPaths.orders,
    component: asyncComponent(() => import("../modules/orders/order-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Sales",
      title: "Orders",
    },
  },
  {
    path: `${appPaths.orders}/:uuid`,
    component: asyncComponent(() => import("../modules/orders/order-edit.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Sales",
      title: "Order Detail",
    },
  },
  {
    path: appPaths.shipments,
    component: asyncComponent(() => import("../modules/shipments/shipments-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "sales",
      title: "Shipments",
    },
  },
  {
    path: appPaths.invoices,
    component: asyncComponent(() => import("../modules/invoices/invoices-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "sales",
      title: "Invoices",
    },
  },
  {
    path: appPaths.transactions,
    component: asyncComponent(() => import("../modules/transactions/transactions-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "sales",
      title: "Transactions",
    },
  },


  /// Catalog
  {
    path: appPaths.products,
    component: asyncComponent(() => import("../modules/products/product-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Catalog",
      title: "Products",
    },
  },
  {
    path: `${appPaths.products}/:uuid`,
    component: asyncComponent(() => import("../modules/products/product-edit.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Catalog",
      title: "Product Detail",
    },
  },
  {
    path: appPaths.categories,
    component: asyncComponent(() => import("../modules/categories/category-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Catalog",
      title: "Categories",
    },
  },
  {
    path: appPaths.woods,
    component: asyncComponent(() => import("../modules/woods/wood-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Catalog",
      title: "Woods",
    },
  },
  {
    path: appPaths.warehouses,
    component: asyncComponent(() => import("../modules/warehouses/warehouse-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Catalog",
      title: "Warehouses",
    },
  },

  {
    path: appPaths.settingsGeneral,
    component: asyncComponent(() => import("../modules/settings/settings.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "Settings",
      title: "Settings",
    },
  },
  {
    path: appPaths.settingsUsers,
    component: asyncComponent(() => import("../modules/users/user-list.vue")),
    meta: {
      requiresAuth: true,
      layout: "ui",
      category: "settings",
      title: "Users",
    },
  },
];
